import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { SerieType, getSeriesResponses } from '../Utils/grafici-utils';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { SelectItem } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';
import { CustomizationService } from 'src/app/service/customization.service';
import { NetworkService } from 'src/app/service/network-service.service';
import { UserService } from 'src/app/service/user-service.service';
import { endpoints } from 'src/endpoint/endpoints';
import { PazientiService } from '../../service/pazienti.service';
import { DateFromTo } from '../Model/date-from-to';
import { getBarChartOptions } from '../Utils/apexchart-opt';

@Component({
  selector: 'app-grafici-domande-frequenza-intensita-attivita-quotidiane',
  templateUrl: './grafici-domande-frequenza-intensita-attivita-quotidiane.component.html',
  styleUrls: ['./grafici-domande-frequenza-intensita-attivita-quotidiane.component.scss']
})
export class GraficiDomandeFrequenzaIntensitaAttivitaQuotidianeComponent implements OnInit {
  @Input() identifier;
  @Input() domande;
  @Input() domanda;
  @Input() titolo;
  @Input() showLabel = true;


  @Input('date') set date(date: DateFromTo) {
    if (!date.compare(this._date)) {
      this.observer.next(date);
    }
  }

  // Usato solo per il report
  @Input() showHeader: boolean;
  @Input() tipoGrafico;
  @Input() altezzaGrafico;
  @Input() larghezzaGrafico;

  // tslint:disable-next-line: variable-name
  _date: DateFromTo;

  observer: BehaviorSubject<DateFromTo>;

  dateFromString: string;
  dateToString: string;
  dateFromTimeStamp;
  dateToTimeStamp;

  opt: SelectItem[];

  selected;
  questions;

  xAxis = {
    type: 'datetime',
    labels: {
      rotate: -45,
      rotateAlways: false,
      offsetX: -15,
      style: {
        fontSize: '12px'
      }
    }
  };

  colors = ['Frequenza', 'Intensità/Non ha influito sulle attività quotidiane', 'Intensità/Ha influito sulle attività quotidiane']

  stroke: ApexStroke = { curve: 'smooth' };
  markers = { size: 4, hover: { size: undefined, sizeOffset: 2 } };

  @ViewChild('chart', { static: true }) chartRef: ElementRef;

  chart: ApexCharts;
  patientId;

  organization;
  // tslint:disable-next-line: max-line-length
  constructor(private http: HttpClient, private toastr: ToastrService, private datePipe: DatePipe, private network: NetworkService,
    private userService: UserService, private patientService: PazientiService, private customizationService: CustomizationService) {
    this.observer = new BehaviorSubject<DateFromTo>(null);
  }

  ngOnInit() {
    this.titolo = this.titolo ?? "";
    const paziente = this.patientService.getPatient();
    this.patientId = paziente.id;

    this.organization = this.userService.getCurrentOrganization();

    if (this.showHeader === undefined) {
      this.showHeader = true;
    }
    // Se vengono passate in input le domande usa quelle, altrimenti usa quelle di default per l'organization
    this.domande = this.domande ?? this.customizationService.getDefaultQuestionnaireNameByOrganizationName(this.userService.getCurrentOrganization());

    // Aggiusto la lista delle domande per renderle compatibili con la logica di questo componente
    let dom = new Array();
    Object.keys(this.domande).forEach(k => {
      dom.push(this.domande[k]);
    });
    this.domande = dom;

    // Seleziono il primo
    if (this.domanda) {
      this.selected = this.domanda
    } else {
      this.selected = this.domande[0];
    }

    console.log("this.selected", this.selected)


    this.observer.subscribe((input) => {
      if (this.identifier && input) {
        this._date = input;
        this.dateFromString = this.datePipe.transform(input.getDateFrom(), 'yyyy-MM-dd');
        this.dateToString = this.datePipe.transform(input.getDateTo(), 'yyyy-MM-dd');
        this.dateFromTimeStamp = Math.round(input.getDateFrom().getTime());
        this.dateToTimeStamp = Math.round(input.getDateTo().getTime());
        this.dropdownChange(this.selected);
      }
    });

  }

  ngOnDestroy(): void {
    this.observer.unsubscribe();
  }

  // getOpt() {
  //   const ret = new Array<SelectItem>();
  //   Object.keys(this.domande).forEach(el => {
  //     ret.push({
  //       label: this.domande[el].graficoName,
  //       value: this.domande[el]
  //     });
  //   });
  //   return ret;
  // }

  getChartArray(input): SerieType {
    return {
      name: input.graficoName,
      color: ['#008FFB', '#00E396', '#df4759'],
      display: [input.graficoName],
      type: ['line', 'bar', 'bar'],
      xaxis: this.xAxis,
      yaxis: this.getYaxis(input.graficoName),
      stroke: this.stroke,
      markers: true,
    } as SerieType;
  }

  dropdownChange(eventt) {
    const event = eventt;
    this.createChart(this.getChartArray(event), event.graficoName.trim() + 'ID', event.testo, event);
  }

  createChart(chartArray: SerieType, id, title, event) {
    this.getData(chartArray, event.graficoName.trim() + 'ID', event.testo ?? event.graficoName, event);
  }

  getData(chartArray: SerieType, id, title, event) {
    let results = [];
    this.http.get(endpoints.elasticQuery + "getSintomi" + "/" + this.patientId + "/" + this.dateFromTimeStamp + "/" + this.dateToTimeStamp + "/" + parseInt(event.code) + "/-answers").toPromise().then(
      (response1: any) => {
        results.push(response1);
        this.http.get(endpoints.elasticQuery + "getSintomi" + "/" + this.patientId + "/" + this.dateFromTimeStamp + "/" + this.dateToTimeStamp + "/" + (parseInt(event.code) + 2) + "/-answers").toPromise().then(
          (response2: any) => {
            results.push(response2);
            this.http.get(endpoints.elasticQuery + "getSintomi" + "/" + this.patientId + "/" + this.dateFromTimeStamp + "/" + this.dateToTimeStamp + "/" + (parseInt(event.code) + 1) + "/-answers").toPromise().then(
              (response3: any) => {
                results.push(response3);
                const series: ApexAxisChartSeries = [];
                let seriesLabels = null;
                let labels = [];
                let type = 'line';
                for (let i = 0; i < results.length; i++) {
                  if (i != 1) {
                    if (i == 2) {
                      type = 'bar';
                    }
                    seriesLabels = getSeriesResponses(results[i], "" + i, chartArray.display, type, this.organization, this.customizationService);

                    if (i > 0) {
                      seriesLabels.serie[0].data = this.fillSeries(series[0].data, seriesLabels.serie[0].data);
                    }
                    if (i > 1) {
                      const s = getSeriesResponses(results[i], "" + i, chartArray.display, type, this.organization, this.customizationService);
                      //this.fillSINO(seriesLabels.serie[0].data, getSeriesResponses(results[1], "" + 1, chartArray.display, type, this.organization, this.customizationService).serie[0].data, '12');
                      let serie2 = JSON.parse(JSON.stringify(seriesLabels));
                      let serie3 = JSON.parse(JSON.stringify(seriesLabels));

                      // 11 -> SI, 12 -> NO
                      this.checkSINO(serie2.serie[0].data, getSeriesResponses(results[1], "" + 1, chartArray.display, type, this.organization, this.customizationService).serie[0].data, "11");
                      this.checkSINO(serie3.serie[0].data, getSeriesResponses(results[1], "" + 1, chartArray.display, type, this.organization, this.customizationService).serie[0].data, "12");
                      serie2.serie[0].name = this.colors[1];
                      if (Array.isArray(serie2.serie)) {
                        serie2.serie.forEach(element => {
                          series.push(element);
                        });
                      } else {
                        series.push(serie2.serie);
                      }
                      serie3.serie[0].name = this.colors[2];
                      if (Array.isArray(serie3.serie)) {
                        serie3.serie.forEach(element => {
                          series.push(element);
                        });
                      } else {
                        series.push(serie3.serie);
                      }
                      continue;
                    }

                    seriesLabels.serie[0].name = this.colors[i];
                    if (Array.isArray(seriesLabels.serie)) {
                      seriesLabels.serie.forEach(element => {
                        series.push(element);
                      });
                    } else {
                      series.push(seriesLabels.serie);
                    }
                    if (i == 0) {
                      labels = seriesLabels.labels;
                    }
                  }
                }
                const chartArr = new Array<SerieType>();

                chartArr.push(chartArray);

                series.forEach(elem => {
                  elem.data = this.removeDuplicates(elem.data)
                })

                // tslint:disable-next-line: max-line-length
                const options = getBarChartOptions(
                  id,
                  title,
                  series,
                  chartArr,
                  labels,
                  chartArray.yaxis,
                  chartArray.stroke,
                  chartArray.markers,
                  chartArray.fill,
                  chartArray.grid,
                  chartArray.xaxis,
                );
                if (this.altezzaGrafico !== undefined) {
                  options.chart.height = this.altezzaGrafico;
                }
                if (this.larghezzaGrafico !== undefined) {
                  options.chart.width = this.larghezzaGrafico;
                }
                options.dataLabels = { enabled: false };
                // options.title.offsetX = 0;

                options.plotOptions = {
                  bar: {
                    horizontal: false,
                    columnWidth: '5%',
                  }
                };

                options.tooltip.shared = true;
                options.tooltip.intersect = false;

                options.chart.stacked = true;

                options.title = {
                  text: title,
                  align: 'center',
                  offsetX: 70,
                  style: {
                    fontSize: '14px',
                  }
                }

                if (this.chart) {
                  this.chart.updateOptions(options, false, false, false);
                  // ApexCharts.exec(id,'updateOptions',options)
                } else {
                  this.chart = new ApexCharts(this.chartRef.nativeElement, options);
                  this.chart.render();
                }
              }
            ).catch(err => {
              // this.getData(chartArray, id, title, event);
              return;
            });;
          }
        ).catch(err => {
          // this.getData(chartArray, id, title, event);
          return;
        });;
      }
    ).catch(err => {
      // this.getData(chartArray, id, title, event);
      return;
    });
  }

  removeDuplicates(list) {
    var result = list.reduce((unique, o) => {
      if (!unique.some(obj => obj.x === o.x)) {
        unique.push(o);
      }
      return unique;
    }, []);
    return result;
  }


  fillSeries(serie1, serie2) {
    let result = [];
    serie1.forEach(elem1 => {
      let find = false;
      let el;
      serie2.forEach(elem2 => {
        if (elem1.x == elem2.x) {
          find = true;
          result.push(elem2);
        }
      })
      if (!find) {
        let point = {
          x: elem1.x,
          y: null
        }
        result.push(point);
      }
    })
    return result;
  }

  checkSINO(serie1, serie2, control) {
    if (serie2.length == 0) {
      if (control == '12') {
        serie1.forEach(elem2 => {
          elem2.y = null;
        })
      }
    }
    if (serie2.length > 0) {
      if (control == '12') {
        serie1.forEach(elem2 => {
          if (elem2.y < 10) {
            elem2.y = null;
          }
        })
      }
    }
    serie2.forEach(elem1 => {
      serie1.forEach(elem2 => {
        if (elem2 != null) {
          if (elem1.x == elem2.x) {
            // Vogliamo i SI ed il paziente ha risposto SI
            if (control == '11' && (elem1.y == control || elem1.y == '-1')) {
              elem2.y = null;
              // Vogliamo i NO ed il paziente ha risposto NO
            } else if (control == '12' && elem1.y == control) {
              elem2.y = null;
            }
          }
        }
      })
    })
    //return result;
  }

  fillSINO(serie1, serie2, control) {
    let result = [];
    serie2.forEach(elem1 => {
      let find = false;
      let el;
      serie1.forEach(elem2 => {
        if (elem1.x == elem2.x) {
          if (elem1.y == control) {
            elem1 = -1;
          }
        }
      })
    })
    return result;
  }

  getYaxis(label) {
    // tslint:disable-next-line: variable-name
    const labels1_3 = {
      style: {
        colors: '#008FFB',
        fontSize: '14px',
      },
      formatter: (val, index) => {
        if (val === 1) {
          return '1-3';
        } else if (val === 2) {
          return '3-8';
        } else if (val === 3) {
          return '>8';
        } else if (val === 4) {
          return '';
        } else if (val === 0) {
          return '0';
        } else {
          return '';
        }
      }
    };

    // tslint:disable-next-line: variable-name
    const labels1_4 = {
      style: {
        colors: '#008FFB',
        fontSize: '14px',
      },
      formatter: (val, index) => {
        if (val === 5) {
          return 'Normale';
        } else if (val === 6) {
          return 'Solida';
        } else if (val === 7) {
          return 'Liquida';
        } else {
          return '';
        }
      }
    };

    const labelsSimple = {
      style: {
        colors: '#008FFB',
        fontSize: '14px',
      },
    };

    const labelsMolto = {
      style: {
        colors: '#008FFB',
        fontSize: '14px',
      },
      formatter: (val, index) => {
        if (val === 17) {
          return 'No';
        } else if (val === 18) {
          return 'Un po\'';
        } else if (val === 19) {
          return 'Molto';
        } else if (val === 20) {
          return 'Moltiss.';
        } else {
          return '';
        }
      },
      minWidth: 60,
      maxWidth: 160
    };

    const labelsSiNo = {
      style: {
        colors: '#008FFB',
        fontSize: '14px',
      },
      formatter: (y, index) => {
        if (typeof y === 'undefined' || y == null) {
          return 'ND';
        } else if (y === 8) {
          return 'No';
        } else if (y === 9) {
          return 'Si';
        }
      }
    };

    const labelsFrequenza = {
      show: true,
      style: {
        colors: '#008FFB',
        fontSize: '14px',
      },
      formatter: (val, index) => {
        if (val === 1) {
          return 'MAI';
        } else if (val === 2) {
          return 'RARAMENTE (massimo 2 giorni)';
        } else if (val === 3) {
          return 'DI FREQUENTE (per 3 o 4 giorni)';
        } else if (val === 4) {
          return 'SPESSO (per 5 giorni)';
        } else if (val === 5) {
          return 'SPESSISSIMO (più di 5 giorni)';
        } else {
          return '';
        }
      },
      minWidth: 350,
      maxWidth: 400
    };

    const labelsFrequenzaIperteso = {
      show: true,
      style: {
        colors: '#008FFB',
        fontSize: '14px',
      },
      formatter: (val, index) => {
        if (val === 0) {
          return 'NON IPERTESO';
        } else if (val === 1) {
          return 'MAI';
        } else if (val === 2) {
          return 'RARAMENTE (massimo 2 giorni)';
        } else if (val === 3) {
          return 'DI FREQUENTE (per 3 o 4 giorni)';
        } else if (val === 4) {
          return 'SPESSO (per 5 giorni)';
        } else if (val === 5) {
          return 'SPESSISSIMO (più di 5 giorni)';
        } else {
          return '';
        }
      },
      minWidth: 350,
      maxWidth: 400
    };

    const labelsFrequenzaGonfiore = {
      show: true,
      style: {
        colors: '#008FFB',
        fontSize: '14px',
      },
      formatter: (val, index) => {
        if (val === 0) {
          return 'MAI';
        } else if (val === 1) {
          return 'RARAMENTE (massimo 2 giorni)';
        } else if (val === 2) {
          return 'DI FREQUENTE (per 3 o 4 giorni)';
        } else if (val === 3) {
          return 'SPESSO (per 5 giorni)';
        } else if (val === 4) {
          return 'SPESSISSIMO (più di 5 giorni)';
        } else {
          return '';
        }
      },
      minWidth: 400,
      maxWidth: 450
    };

    const labelsIntensità = {
      show: true,
      style: {
        colors: '#00E396',
        fontSize: '14px',
      },
      formatter: (val, index) => {
        if (val === 6) {
          return '1';
        } else if (val === 7) {
          return '2';
        } else if (val === 8) {
          return '3';
        } else if (val === 9) {
          return '4';
        } else if (val === 10) {
          return '5';
        }
      }
    };

    const labelsIntensità1 = {
      show: false,
      style: {
        colors: '#00E396',
        fontSize: '14px',
      },
      formatter: (val, index) => {
        if (val === 6) {
          return '1';
        } else if (val === 7) {
          return '2';
        } else if (val === 8) {
          return '3';
        } else if (val === 9) {
          return '4';
        } else if (val === 10) {
          return '5';
        }
      }
    };

    const yAxis: ApexYAxis = {
      axisTicks: {
        show: true
      },
      axisBorder: {
        show: true,
        color: '#008FFB'
      },
      seriesName: 'Frequenza',
      labels: {
        show: this.showLabel,
        style: {
          colors: '#008FFB',
          fontSize: '30px',
        }
      },
      title: {
        text: 'Frequenza',
        offsetX: -10,
        style: {
          color: '#008FFB',
          fontSize: '14px',
        }
      },
    };

    // if (label.includes("se iperteso")) {
    //   yAxis.labels = labelsFrequenzaIperteso;
    // } else if (label.includes("gonfiore alle gambe")) {
    //   yAxis.labels = labelsFrequenzaGonfiore;
    // } else {
    // }
    yAxis.labels = labelsFrequenza;

    // yAxis.labels = labelsFrequenza;
    yAxis.min = -5;
    yAxis.max = 5;
    yAxis.tickAmount = 10;

    const yAxis1: ApexYAxis = {
      axisTicks: {
        show: true
      },
      axisBorder: {
        show: true,
        color: '#00E396'
      },
      seriesName: 'Intensità',
      opposite: true,
      labels: {
        show: this.showLabel,
        style: {
          colors: "#00E396",
          fontSize: '30px',
        }
      },
      title: {
        text: 'Intensità',
        offsetX: 10,
        style: {
          color: '#00E396',
          fontSize: '14px',
        }
      },
    };

    yAxis1.labels = labelsIntensità;
    yAxis1.min = 6;
    yAxis1.max = -5;
    yAxis1.tickAmount = 11;


    const yAxis2: ApexYAxis = {
      axisTicks: {
        show: false
      },
      axisBorder: {
        show: false,
        color: '#00E396'
      },
      seriesName: 'Intensità',
      opposite: true,
      labels: {
        show: this.showLabel,
        style: {
          colors: "#00E396",
          fontSize: '30px',
        }
      },
      title: {
        text: '',
        offsetX: 10,
        style: {
          color: '#00E396',
          fontSize: '14px',
        }
      },
    };

    yAxis2.labels = labelsIntensità1;
    yAxis2.min = 6;
    yAxis2.max = -5;
    yAxis2.tickAmount = 11;

    const yAxiss = [
      yAxis,
      yAxis1,
      yAxis2
    ]

    return yAxiss;
  }
}
